import React from 'react';
import { Col } from 'react-bootstrap';
import * as styles from '../css/image-with-logo.css';
import type { Logo } from './PoweringImage';
import PoweringImage from './PoweringImage';

interface Props {
    src: string;
    logo: Logo;
}

const ImageWithLogo = ({ src, logo }: Props) => (
    <Col className={styles.root}>
        <img src={src} alt={src} className={styles.image} />
        <PoweringImage logo={logo} />
    </Col>
);

export default ImageWithLogo;
